var map = {
	"./110.png": "e9ba",
	"./117.png": "1700",
	"./adown-btn.png": "01e0",
	"./adownload-btn.png": "5d62",
	"./adownload-btn1.png": "836c",
	"./appointment.png": "cf2e",
	"./apre-btn.png": "afb7",
	"./apre-btn2.png": "3f84",
	"./bgv.mp4": "78eb",
	"./bsdown-btn.png": "5192",
	"./copyright-bg.jpg": "7768",
	"./down-btn.png": "77d3",
	"./downtips.png": "257e",
	"./facebook_fans_landscape.png": "274c",
	"./feature1.jpg": "522c",
	"./feature2.jpg": "a0da",
	"./feature3.jpg": "e4b3",
	"./feature4.jpg": "727c",
	"./feature5.jpg": "c28c",
	"./feature6.jpg": "c292",
	"./footer-info.png": "06e9",
	"./gdown-btn.png": "7b00",
	"./gdownload-btn.png": "eb89",
	"./gpre-btn.png": "6106",
	"./header_bg.jpg": "118d",
	"./hicon-kuang-bai.png": "6f20",
	"./hicon-kuang-zi.png": "0c92",
	"./hicon1.png": "b6d9",
	"./hicon2.png": "185c",
	"./hicon3.png": "5476",
	"./hicon4.png": "45f2",
	"./hicon5.png": "8336",
	"./hicon6.png": "6ac5",
	"./kunyuedown-btn.png": "dcc3",
	"./kunyuedown-btn2.png": "a795",
	"./l-btn.png": "9154",
	"./lddown-btn.png": "ce2c",
	"./logo.png": "a825",
	"./main-bg.jpg": "ab27",
	"./main_bg_01.jpg": "ad64",
	"./main_bg_02.jpg": "a67c",
	"./main_bg_03.jpg": "b4c7",
	"./main_bg_04.jpg": "d2bd",
	"./main_bg_05.jpg": "d238",
	"./main_bg_06.jpg": "3bb1",
	"./main_bg_07.png": "a7e1",
	"./newpage-bg.jpg": "fe2a",
	"./news-bg.png": "bc82",
	"./news-container-bg.png": "b60c",
	"./news-fb-container-bg.png": "74bf",
	"./news/20110201_01.jpg": "deb4",
	"./news/20110201_02.jpg": "4ded",
	"./news/20110201_03.jpg": "f00e",
	"./news/20110201_04.jpg": "fe52",
	"./news/20110201_05.jpg": "e958",
	"./news/20110201_06.jpg": "9344",
	"./newsTop1.jpg": "26a3",
	"./newsTop1.png": "8d77",
	"./newsTop2.jpg": "e174",
	"./newsTop3.jpg": "0954",
	"./newsTop4.jpg": "dec8",
	"./newsTop5.jpg": "4603",
	"./play-btn.png": "2b7b",
	"./r-btn.png": "b3e3",
	"./reward1.png": "d2bd1",
	"./reward2.png": "d21f",
	"./reward3.png": "e696",
	"./reward4.png": "6537",
	"./reward5.png": "6319",
	"./reward_bg.png": "79d2",
	"./reward_completed.png": "81db",
	"./rinfo1.png": "87b8",
	"./rinfo2.png": "e8dc",
	"./rinfo3.png": "4f91",
	"./rinfo4.png": "7cf1",
	"./rinfo5.png": "4c4a",
	"./rinfo6.png": "54a0",
	"./role1.png": "b0ba",
	"./role2.png": "a157",
	"./role3.png": "2848",
	"./role4.png": "69d0",
	"./role5.png": "f860",
	"./role6.png": "e412",
	"./sb-b.png": "a199",
	"./sb-y.png": "bb28",
	"./stage-bg.png": "92bb",
	"./story_pic_1.png": "e978",
	"./story_pic_2.png": "0343",
	"./story_pic_3.png": "b948",
	"./story_pic_4.png": "7f5c",
	"./story_pic_5.png": "9d65",
	"./storyinfo.png": "296d",
	"./thunder-btn.png": "94f0",
	"./title-feature.png": "f9e0",
	"./title-heros.png": "3cd6",
	"./title-news.png": "a885a",
	"./title-reward.png": "e303",
	"./title-story.png": "c299",
	"./top.png": "1dcb",
	"./vplay-bg.png": "4bf1",
	"./vplay-btn.png": "2c11",
	"./yinghua.png": "aa68",
	"./世界觀.png": "0308",
	"./人物介紹.png": "f276",
	"./新聞.png": "212c",
	"./獎勵.png": "ca68",
	"./遊戲特色.png": "ce1a",
	"./首頁.png": "c07f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e47";